import achievementBg from './achievements/achievement-bg.png';

import logo from './icons/logo.svg';
import activerse from './icons/activerse_logo_horizontal.svg';
import backIcon from './icons/back.svg';

import eye from './icons/eye-solid.svg';
import eyeSlash from './icons/eye-slash-solid.svg';

import unauthorized from './other-pages/unauthorized.png';

import favouriteFull from './cookbook/fav_on.png';
import favouriteEmpty from './cookbook/fav_off.png';
import favouriteFullSmall from './cookbook/fav_small_on.png';
import favouriteEmptySmall from './cookbook/fav_small_off.png';
import favouritesIcon from './cookbook/favourites-icon.svg';
import searchIcon from './cookbook/input_icon_search.svg';
import cookbookFavMealsIcon from './title-bar/cookbook-fav-meals.svg';

import playBtn from './dayplan/play-button.svg';

import instacartLogo from './icons/instacart.svg';

import minus from './cookbook/minus.svg';
import minusMulti from './cookbook/minus_multi.svg';
import plus from './cookbook/plus.svg';
import plusMulti from './cookbook/plus_multi.svg';
import star from './cookbook/star.svg';

import iconChange from './cookbook/change.svg';
import iconChangeDone from './cookbook/change_active.svg';
import iconChangeActive from './cookbook/change_replace.svg';

import glass from './hydration/glass.svg';
import bottle from './hydration/bottle.svg';
import custom from './hydration/custom.svg';

import hydrationSuccessIcon from './hydration/hydration_goal_achieved.svg';
import hydrationSuccessIconLarge from './hydration/hydration_goal_achieved_large.svg';

import error404Img from './errors/error_404.png';
import genericErrorImg from './errors/error_unknown.png';
import networkErrorImg from './errors/error_network.png';
import noAccountErrorImg from './errors/login_fail_social.png';
import envelope from './remove-account/envelope.svg';
import removeAccountSuccess from './remove-account/success.svg';
import removeAccountAlert from './remove-account/alert.svg';
import removeAccountError from './remove-account/error.svg';

import settingsIcon from './icons/settings.svg';

import appStore from './icons/app_store_badge.svg';
import googlePlay from './icons/google_play_badge.svg';

import imagePlaceholder from './image-placeholder.jpeg';
import thankYouPageBg from './thankyou/thank-u-page-main-img@2x.png';
import thankYouPageBgMobile from './thankyou/thank-u-page-main-img-mob@2x.png';
import thankYouPageAppEn from './thankyou/img-app-en@2x.png';
import thankYouPageAppSe from './thankyou/img-app-se@2x.png';
import thankYouPageLogInEn from './thankyou/img-log-in-en@2x.png';
import thankYouPageLogInSe from './thankyou/img-log-in-se@2x.png';

import confirm from './confirm/confirm.png';

import ratingStarEmpty from './dayplan/info.ratingStarEmpty.svg';
import ratingStarHalf from './dayplan/info.ratingStarHalf.svg';
import ratingStarFull from './dayplan/info.ratingStarFull.svg';

import ratingStarPopupEmpty from './dayplan/popup.ratingStarEmpty.svg';
import ratingStarPopupFull from './dayplan/popup.ratingStarFull.svg';

import ratingButtonEmpty from './dayplan/button.ratingStar.empty.svg';
import ratingButtonFull from './dayplan/button.ratingStar.full.svg';

import noSearchResultsIcon from './dayplan/no_search_results_icon.svg';

import DownArrow from './icons/chevron-down.svg?react';

const images = {
  achievementBg,
  logo,
  activerse,
  backIcon,
  eye,
  eyeSlash,
  unauthorized,
  favouriteFull,
  favouriteEmpty,
  favouriteFullSmall,
  favouriteEmptySmall,
  favouritesIcon,
  searchIcon,
  cookbookFavMealsIcon,
  playBtn,
  instacartLogo,
  minus,
  minusMulti,
  plus,
  plusMulti,
  star,
  iconChange,
  iconChangeDone,
  iconChangeActive,
  glass,
  bottle,
  custom,
  hydrationSuccessIcon,
  hydrationSuccessIconLarge,
  error404Img,
  genericErrorImg,
  networkErrorImg,
  noAccountErrorImg,
  envelope,
  removeAccountSuccess,
  removeAccountAlert,
  removeAccountError,
  settingsIcon,
  appStore,
  googlePlay,
  imagePlaceholder,
  thankYouPageBg,
  thankYouPageBgMobile,
  thankYouPageAppEn,
  thankYouPageAppSe,
  thankYouPageLogInEn,
  thankYouPageLogInSe,
  confirm,
  ratingStarEmpty,
  ratingStarHalf,
  ratingStarFull,
  ratingButtonEmpty,
  ratingButtonFull,
  ratingStarPopupEmpty,
  ratingStarPopupFull,
  noSearchResultsIcon,
};

export const svgInlineMaster = {
  DownArrow,
};

export default images;
